import { render, staticRenderFns } from "./cargoOwner.vue?vue&type=template&id=1d38d198&scoped=true&"
import script from "./cargoOwner.vue?vue&type=script&lang=js&"
export * from "./cargoOwner.vue?vue&type=script&lang=js&"
import style0 from "./cargoOwner.vue?vue&type=style&index=0&id=1d38d198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38d198",
  null
  
)

export default component.exports